$(document).ready(()=>{

    function initZoom() {
      try {
        var zoomElm = $(".product-img-box [data-zoom]");
  
        if (win.width() >= 1200) {
          zoomElm.zoom();
        } else {
          zoomElm.trigger("zoom.destroy");
        }
      } catch (err)
      {
        
      }
    }
    function changeSwatch(swatchSlt) {
      $(document).on("change", swatchSlt, function () {
        var className = $(this).data("filter");
        var optionIndex = $(this).closest(".swatch").attr("data-option-index");
        var optionValue = $(this).val();

        
        if (optionValue == "Black") {
          $(".blackonly").show();
          try {
            if ($("#yesPVCNoOverlays").length > 0)
            {
              $("#yesPVCNoOverlays").attr("disabled",true);
              if ($("#yesPVCNoOverlays").is(":checked"))
              {
                $("#PVCno").click();
              }
            }
          }
          catch (error)
          {
            console.log(e);
          }
        } else {
          $(".blackonly").hide();
          try {
            if ($("#yesPVCNoOverlays").length > 0)
            {
              $("#yesPVCNoOverlays").attr("disabled",false);
            }
          }
          catch (error)
          {
            console.log(e);
          }
        }

        $(this)
          .closest("form")
          .find(".single-option-selector")
          .eq(optionIndex)
          .val(optionValue)
          .trigger("change");

        if (className == undefined) {
          if ($("input[data-filter]").is(":checked")) {
            var checked = $("input[data-filter]:checked").data("filter");
            className = checked;
          }
        }

        if (
          window.color_swatch_style === "variant_grouped" &&
          window.use_color_swatch &&
          className !== undefined
        ) {
          var productShop = $(swatchSlt).closest(".product-shop");

          if (productShop.closest(".product-slider").length) {
            var productImgs = productShop
                .closest(".product-slider")
                .find("[data-moreview-product-slider]"),
              sliderFor = productImgs.find(".slider-for");

            sliderFor.slick("slickUnfilter");

            if (sliderFor.find(className).length) {
              sliderFor.slick("slickFilter", className).slick("refresh");
            }
            initZoom();
          } else {
            var productImgs = productShop.prev("[data-more-view-product]");

            if (productImgs.length) {
              var sliderNav = productImgs.find(".slider-nav"),
                sliderFor = productImgs.find(".slider-for");

              sliderNav.slick("slickUnfilter");
              sliderFor.slick("slickUnfilter");

              if (
                sliderNav.find(className).length &&
                sliderFor.find(className).length
              ) {
                sliderNav.slick("slickFilter", className).slick("refresh");
                sliderFor.slick("slickFilter", className).slick("refresh");
              }
            }
            initZoom();
          }
        }
      });
    }

    setTimeout(()=>{
      changeSwatch("#add-to-cart-form .swatch :radio");
      //$(".swatch-content :radio:checked").trigger("change");
    },0);






  
  function initSelectSwatchGrid() {
    $("body").on("change", ".select-swatch",  function(){
    var self = $(this),
        title = self.find(":selected").attr("data-title").replace(/^\s+|\s+$/g, ""),
        productItemElm = self.closest(".grid-item"),
        sidebarWidgetProduct = productItemElm.closest(
          ".sidebar-widget-product"
        );
    var get_json = $(this).parents(".product-item").data("json-product");
    var list_cur_media = [];
    
    var product_id = $(this).data("id-product");
    productItemElm.find("[name=id]").val($(this).find(":selected").val());
    var href = productItemElm.find("a").attr("href");
    productItemElm
      .find("a:not(.btn-cancel):not(.number-showmore)")
      .attr(
        "href",
        href.split("?variant=")[0] + "?variant=" + product_id
      );
    productItemElm.find(".product-title").hasClass("change-text")
            ? productItemElm
                .find(".product-title")
                .find("[data-change-title]")
                .text(" - " + title)
            : productItemElm
                .find(".product-title")
                .addClass("change-text")
                .append("<span data-change-title> - " + title + "</span>");


    var quantity = self.find(":selected").attr("data-quantity");
    if (quantity>0) {
      productItemElm
        .find("[data-btn-addtocart]")
        .removeClass("disabled")
        .removeAttr("disabled");
      productItemElm
        .find("[data-btn-addtobundle]")
        .attr("disabled",false)
        .removeClass("disabled")
        .removeAttr("disabled");
      productItemElm
        .find("[data-btn-addtocart]")
        .text(window.inventory_text.add_to_cart);
      productItemElm
        .find("[data-btn-addtobundle]")
        .text(window.inventory_text.add_to_bundle);
      
      
    } else {
      productItemElm
        .find("[data-btn-addtocart]")
        .addClass("disabled")
        .attr("disabled", "disabled");
      productItemElm
        .find("[data-btn-addtocart]")
        .text(window.inventory_text.sold_out);
      
      
      productItemElm
        .find("[data-btn-addtobundle]")
        .addClass("disabled")
        .attr("disabled", "disabled");
      productItemElm
        .find("[data-btn-addtobundle]")
        .text(window.inventory_text.sold_out);
      
    }
    
    if (self.find(":selected").data("preorder") != undefined && self.find(":selected").data("preorder")==1)
    {
      productItemElm
      .find("[data-btn-addtocart]")
      .text(window.inventory_text.pre_order);
      productItemElm
      .find("[data-btn-addtobundle]")
      .text(window.inventory_text.pre_order);
      if (self.attr("data-preorder"))
        productItemElm.find("[name*=_backorder]").val(self.attr("data-preorder").trim());
      if (self.attr("data-shipdays"))
        productItemElm.find("[name*=_shipdays]").val(self.attr("data-shipdays").trim());
    }
    else
    {
      productItemElm.find("[name*=_backorder]").val(0);
      productItemElm.find("[name*=_shipdays]").val(0);
    }
    var price = self.find(":selected").data("price"),
      comparePrice = self.find(":selected").data("compare_at_price");
    if (comparePrice > price) {
      productItemElm
        .find("[data-compare-price-grid]")
        .html(Shopify.formatMoney(comparePrice, window.money_format));
    } else {
      productItemElm.find("[data-compare-price-grid]").html("");
    }

    productItemElm
      .find(".price-box")
      .html(Shopify.formatMoney(price, window.money_format));

    if (self.find(":checked") && self.find(":checked").attr("data-image"))
    {
      productItemElm.find(
                ".product-grid-image > picture > *, .product-grid-image > img"
              )
              .attr({
                srcset: self.find(":checked").attr("data-image"),
              });
    }
  });
  }
  
  function initColorSwatchGrid() {
    initSelectSwatchGrid();

    
    var itemSwatchSlt = ".item-swatch li label, [data-bundle-grouped-swatch]  li label";

    $("body")
      .off("click.toggleClass")
      .on("click.toggleClass", itemSwatchSlt, function () {
        $(this)
          .parents(".inner-top")
          .find(".action")
          .removeClass("show-popup-qs");
        var self = $(this),
          title = self.attr("data-title").replace(/^\s+|\s+$/g, ""),
          productItemElm = self.closest(".grid-item"),
          sidebarWidgetProduct = productItemElm.closest(
            ".sidebar-widget-product"
          );

        self.parents(".item-swatch").find("li label").removeClass("active");
        self.addClass("active");
        var get_json = $(this).parents(".product-item").data("json-product");
        var list_cur_media = [];
        // debugger;
        var product_id = $(this).data("id-product");
        var href = productItemElm.find("a").attr("href");
        productItemElm
          .find("a:not(.btn-cancel):not(.number-showmore)")
          .attr(
            "href",
            href.split("?variant=")[0] + "?variant=" + product_id
          );

        productItemElm.find(".product-title").hasClass("change-text")
          ? productItemElm
              .find(".product-title")
              .find("[data-change-title]")
              .text(" - " + title)
          : productItemElm
              .find(".product-title")
              .addClass("change-text")
              .append("<span data-change-title> - " + title + "</span>");
        
        if (self.data("with-one-option") != undefined) {
          var quantity = self.data("quantity");
          productItemElm
            .find('[name="id"]')
            .val(self.data("with-one-option"));
          if (quantity > 0) {
            productItemElm
              .find("[data-btn-addtocart]")
              .removeClass("disabled")
              .removeAttr("disabled");
            productItemElm
              .find("[data-btn-addtobundle]")
              .attr("disabled",false)
              .removeClass("disabled")
              .removeAttr("disabled");
            productItemElm
              .find("[data-btn-addtocart]")
              .text(window.inventory_text.add_to_cart);
            productItemElm
              .find("[data-btn-addtobundle]")
              .text(window.inventory_text.add_to_bundle);
            
            
          } else {
            productItemElm
              .find("[data-btn-addtocart]")
              .addClass("disabled")
              .attr("disabled", "disabled");
            productItemElm
              .find("[data-btn-addtocart]")
              .text(window.inventory_text.sold_out);
            
            
            productItemElm
              .find("[data-btn-addtobundle]")
              .addClass("disabled")
              .attr("disabled", "disabled");
            productItemElm
              .find("[data-btn-addtobundle]")
              .text(window.inventory_text.sold_out);
            
          }
          
          if (self.data("preorder") != undefined && self.data("preorder")==1)
          {
            productItemElm
            .find("[data-btn-addtocart]")
            .text(window.inventory_text.pre_order);
            productItemElm
            .find("[data-btn-addtobundle]")
            .text(window.inventory_text.pre_order);
            productItemElm.find("[name*=_backorder]").val($(this).attr("data-preorder").trim());
            productItemElm.find("[name*=_shipdays]").val($(this).attr("data-shipdays").trim());
          }
          else
          {
            productItemElm.find("[name*=_backorder]").val(0);
            productItemElm.find("[name*=_shipdays]").val(0);
          }
          
          var price = self.data("price"),
            comparePrice = self.data("compare_at_price");
          
          if (comparePrice > price) {
            productItemElm
              .find("[data-compare-price-grid],.price-box")
              .html(Shopify.formatMoney(comparePrice, window.money_format));
          } else {
            productItemElm.find("[data-compare-price-grid],.price-box").html("");
          }

          productItemElm
            .find("[data-price-grid],.price-box")
            .html(Shopify.formatMoney(price, window.money_format));
        } else {
          if (get_json != undefined) {
            ella.checkStatusSwatchQs($(this).parents(".product-item"));
          }
          
          if ($(".template-collection").length) {
            if (
              $(this).parents(".product-collection").hasClass("products-list")
            ) {
              productItemElm
                .find(".product-details")
                .find('[data-value="' + title + '"]')
                .find("label")
                .trigger("click");
            } else {
              productItemElm
                .find(".action:eq(0)")
                .find('[data-value="' + title + '"]')
                .find("label")
                .trigger("click");
            }
          } else {
            productItemElm
              .find('[data-value="' + title + '"]')
              .find("label")
              .trigger("click");
          }
        }

        if (get_json != undefined) {
          var list_cur_media = get_json.media.filter(function (cur) {
            return cur.alt === title;
          });
        }

        if (
          list_cur_media.length > 0 &&
          window.color_swatch_style == "variant_grouped"
        ) {
          if (list_cur_media.length > 1) {
            var length = 2;
          } else {
            var length = list_cur_media.length;
          }
          for (var i = 0; i < length; i++) {
            productItemElm
              .find('picture[data-index="' + i + '"] > *')
              .attr("srcset", list_cur_media[i].src);
          }
        } else {
          var newImage = self.data("img");
          if (sidebarWidgetProduct.length) {
            newImage = newImage.replace("800x", "large");
          }
          if (newImage) {
            productItemElm
              .find(
                ".product-grid-image > picture > *, .product-grid-image > img"
              )
              .attr({
                srcset: newImage,
              });
            return false;
          }
        }
      });
    $("body")
      .off("click.showmore")
      .on("click.showmore", ".item-swatch-more a", function () {
        // $('.item-swatch-more a').off('click').on('click', function() {
        $(this).parents(".item-swatch").toggleClass("show--more");
        $(this).parents(".item-swatch").hasClass("show--more")
          ? $(this).children().text("-")
          : $(this).children().text("+");
      });
  }


  setTimeout(()=>{
    initColorSwatchGrid();
  },0);
});